if (!customElements.get('gender-switcher')) {
    class GenderSwitcher extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.addEventListener('click', this.onClick);
        }
        disconnectedCallback() {
            this.removeEventListener('click', this.onClick);
        }
        onClick = (event) => {
            const link = event.target?.closest('a[href]');
            if (!link || !this.contains(link))
                return;
            if (event.defaultPrevented ||
                event.button !== 0 ||
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey) {
                return;
            }
            const productInfo = this.closest('product-info');
            if (!productInfo?.swapToProduct)
                return;
            event.preventDefault();
            this.setLoading(true);
            productInfo.swapToProduct(link.getAttribute('href'), { updateFullPage: true }).catch(() => {
                this.setLoading(false);
            });
        };
        setLoading(loading) {
            this.classList.toggle('is-loading', loading);
            this.querySelectorAll('.gender-switcher__button').forEach((button) => {
                if (loading) {
                    button.setAttribute('aria-disabled', 'true');
                }
                else {
                    button.removeAttribute('aria-disabled');
                }
            });
        }
    }
    customElements.define('gender-switcher', GenderSwitcher);
}
